import { render, staticRenderFns } from "./dingd-list.vue?vue&type=template&id=cd01e990&scoped=true"
import script from "./dingd-list.vue?vue&type=script&lang=js"
export * from "./dingd-list.vue?vue&type=script&lang=js"
import style0 from "./dingd-list.vue?vue&type=style&index=0&id=cd01e990&prod&scoped=true&lang=css"
import style1 from "./dingd-list.vue?vue&type=style&index=1&id=cd01e990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd01e990",
  null
  
)

export default component.exports